<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-card>
        <v-layout row wrap justify-end> </v-layout>
        <v-layout row wrap pa-2>
          <!-- <v-flex lg3 md3 sm12>
            <v-autocomplete
              label="Đầu bao"
              class="input-group--focused"
              :items="prefixBigpackages"
              item-text="name"
              item-value="value"
              v-model="currentItem.PrefixBigpackage"
              :disabled="currentItem.ID > 0"
            ></v-autocomplete>
          </v-flex> -->
          <v-flex lg3 md3 sm12>
            <v-text-field
              label="Biển số xe"
              class="input-group--focused"
              outlined
              dense
              v-model="currentItem.LicensePlate"
              :disabled="!canEditLicensePlate"
              hint="Chỉ kế toán mới được sửa sau khi đã lưu biển số"
              persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <mh-date-picker
              plabel="Ngày bốc hàng"
              class="input-group--focused date-picker"
              v-model="orderDate"
              @onChangeDate="orderDate = $event"
            ></mh-date-picker>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <mh-date-picker
              plabel="Ngày hạ hàng"
              class="input-group--focused date-picker"
              v-model="storeDate"
              @onChangeDate="storeDate = $event"
            ></mh-date-picker>
          </v-flex>
        </v-layout>
        <v-layout row wrap pa-2>
          <v-flex lg3 md3 sm12>
            <h-currency-input
              label="Tổng cân"
              v-model="currentItem.Weight"
              :decimal="1"
              class="input-group--focused"
              disabled
            ></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input
              label="Tổng khối"
              v-model="currentItem.Volume"
              :decimal="2"
              class="input-group--focused"
              disabled
            ></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <h-currency-input
              label="Tổng mã"
              v-model="currentItem.NumberOfProduct"
              :decimal="0"
              class="input-group--focused"
              disabled
            ></h-currency-input>
          </v-flex>
          <v-flex lg3 md3 sm12>
            <v-select
              label="Trạng thái"
              v-model="currentItem.Status"
              :items="receive_type_list"
              item-text="name"
              item-value="value"
              class="input-group--focused"
              outlined
              dense
              disabled
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap pa-6>
          <v-flex lg12 md12 sm12>
            <v-layout row wrap justify-space-between pr-1>
              <div>
                <v-btn
                  class="mx-2"
                  small
                  color="green"
                  @click="showUnloadDialog = true"
                  :disabled="!currentItem.ID || !currentItem.LicensePlate"
                  >Hạ hàng</v-btn
                >
                <v-btn
                  class="mx-2"
                  small
                  color="red"
                  @click="printTruckList"
                  :disabled="!currentItem.ID || details.length === 0"
                  ><v-icon>print</v-icon> In danh sách</v-btn
                >
              </div>
              <div>
                <!-- <v-btn
                  class="mx-2"
                  small
                  color="blue"
                  @click="saveAllProduct()"
                  :disabled="!currentItem.ID || currentItem.Status == receive_type.nhap_kho_vn"
                  >Nhập tất cả</v-btn
                > -->
                <v-btn
                  class="mx-2"
                  small
                  color="red"
                  @click="addDetail"
                  :disabled="!canEditProducts"
                  ><v-icon dark>add</v-icon></v-btn
                >
              </div>
            </v-layout>
          </v-flex>
          <v-flex lg12>
            <v-data-table
              :headers="detail_header"
              :items="details"
              :options.sync="detailOptions"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:item="{ item }">
                <tr :style="{'background-color': item.UnloadPack && item.UnloadPack < item.OrderNumberOfPack ? '#ffcccc' : ''}">
                  <td>{{ item.CustomerCode }}</td>
                  <td>{{ item.DirectName }}</td>
                  <td>{{ item.Code }}</td>
                  <td class="text-right">
                    <v-tooltip right color="grey lighten-3" transition="expand-transition">
                          <template v-slot:activator="{ on }">
                              <p v-on="on" :style="{'color': item.Deposit ? 'rgb(32, 165, 58)' : ''}">{{ item.Deposit | currency('', 2) }}</p>
                              <p style="font-size: 11px;">{{ (item.Deposit * item.ExchangeRate) | currency }}</p>
                          </template>
                          <span>
                              <v-list width="350" color="transparent">
                                  <v-list-item>
                                      <v-list-item-title>Ship nội địa: </v-list-item-title>
                                      <v-list-item-subtitle>{{ item.TransactionDeposit | currency('¥',
                                          1)}}</v-list-item-subtitle>
                                  </v-list-item>
                                  <v-list-item>
                                      <v-list-item-title>Chi xe kéo: </v-list-item-title>
                                      <v-list-item-subtitle>{{ item.PedicabDeposit | currency('¥',
                                          1)}}</v-list-item-subtitle>
                                  </v-list-item>
                                  <v-list-item>
                                      <v-list-item-title>Chi xe nâng: </v-list-item-title>
                                      <v-list-item-subtitle>{{ item.LoadDeposit | currency('¥',
                                          1)}}</v-list-item-subtitle>
                                  </v-list-item>
                                  <v-list-item>
                                      <v-list-item-title>Phí đóng gỗ: </v-list-item-title>
                                      <v-list-item-subtitle>{{ item.ReinforceDeposit | currency('¥',
                                          1)}}</v-list-item-subtitle>
                                  </v-list-item>
                              </v-list>
                          </span>
                      </v-tooltip>
                  </td>
                  <!-- <td class="text-right">{{ item.ExchangeRate | currency }}</td> -->
                  <td class="text-right">
                    {{ item.Weight | currency("", 1) }}
                  </td>
                  <td class="text-right">
                    {{ item.Volume | currency("", 3) }}
                  </td>
                  <td class="text-right">
                    {{ item.OrderNumberOfPack | currency }}
                  </td>
                  <td class="text-right">
                    {{ item.UnloadPack | currency }}
                  </td>
                  <td>{{ item.Status | display_value(product_status_list) }}</td>
                  <td class="text-center">
                    <v-icon 
                      medium 
                      @click="deleteDetail(currentItem.ID, item.ID)"
                      :disabled="!canEditProducts"
                      :style="{cursor: canEditProducts ? 'pointer' : 'not-allowed', opacity: canEditProducts ? 1 : 0.5}"
                    >delete</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
    <v-dialog v-model="dialogItem" max-width="1300px">
      <v-card>
        <v-card-title>
          <span class="title">Danh sách hàng hóa</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1 white--text" @click="dialogItem = false"
            >Đóng</v-btn
          >
          <v-btn @click="onSelectDetail"
            >Lưu lại</v-btn
          >
        </v-card-actions>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <hpo-filter
                  :headers="popup_header"
                  :viewName="popupViewName"
                  v-on:applyFilter="applyFilterDetail"
                  v-on:quickFilter="quickFilterDetail"
                ></hpo-filter>
                <v-data-table
                  fixed-header
                  height="450px"
                  :headers="popup_header"
                  :items="popup_items"
                  item-key="ID"
                  :options.sync="pagination"
                  :footer-props="items_per_page"
                  :server-items-length="popup_total"
                  show-select
                  v-model="selectedDetail"
                >
                  <template v-slot:item="{ item, isSelected, select }">
                    <tr :active="isSelected" @click="select(!isSelected)">
                      <td>
                        <v-checkbox
                          primary
                          hide-details
                          :input-value="isSelected"
                        ></v-checkbox>
                      </td>
                      <td>{{ item.UserName }}</td>
                      <td>{{ item.DirectName }}</td>
                      <td>{{ item.Code }}</td>
                      <td class="text-right">
                        {{ item.Deposit | currency("", 2) }}
                      </td>
                      <!-- <td class="text-right">{{ item.ExchangeRate | currency }}</td> -->
                      <td class="text-right">
                        {{ item.Weight | currency("", 1) }}
                      </td>
                      <td class="text-right">
                        {{ item.Volume | currency("", 2) }}
                      </td>
                      <td class="text-right">{{ item.AvailableNumberOfPack | currency }}</td>
                      <td class="text-right">
                        <v-text-field
                          v-model.number="loadPackQuantities[item.ID]"
                          type="number"
                          step="1"
                          min="0"
                          :max="item.AvailableNumberOfPack"
                          dense
                          outlined
                          hide-details
                          @input="validateLoadPack(item)"
                          @click.stop
                        ></v-text-field>
                      </td>
                      <td class="text-right">{{ calculateRemainingPack(item) | currency }}</td>
                      <td>{{ item.ProductType | display_value(product_types, 'ID', 'Name') }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    
    <!-- Dialog Hạ Hàng -->
    <v-dialog v-model="showUnloadDialog" max-width="1200px" persistent>
      <v-card>
        <v-card-title>
          <span class="title">Hạ hàng - Xe {{ currentItem.LicensePlate }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-data-table
              :headers="unload_headers"
              :items="details"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.Code }}</td>
                  <td>{{ item.UserName }}</td>
                  <td>{{ item.Code }}</td>
                  <td class="text-right">{{ item.OrderNumberOfPack | currency }}</td>
                  <td class="text-right">
                    <v-text-field
                      v-model.number="item.UnloadPack"
                      type="number"
                      step="1"
                      min="0"
                      :max="item.OrderNumberOfPack"
                      dense
                      outlined
                      hide-details
                      class="mt-2"
                      @input="validateUnloadPack(item)"
                    ></v-text-field>
                  </td>
                  <td class="text-right">{{ ((item.OrderNumberOfPack || 0) - (item.UnloadPack || 0)) | currency }}</td>
                  <td class="text-center">
                    <v-btn
                      small
                      color="green"
                      @click="confirmUnloadItem(item)"
                      :disabled="!item.UnloadPack || item.UnloadPack <= 0"
                    >Xác nhận</v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="cancelUnload">Đóng</v-btn>
          <v-btn color="green darken-1" text @click="confirmUnload">Lưu</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- System Logs Section -->
    <v-container grid-list-xl fluid v-if="currentItem.ID">
      <v-card>
        <v-card-title>
          <span class="subtitle-1">Nhật ký chỉnh sửa</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="log_headers"
            :items="systemLogs"
            :loading="loadingLogs"
            disable-pagination
            hide-default-footer
            dense
          >
            <template v-slot:item.created_at="{ item }">
              {{ item.created_at | display_date }}
            </template>
            <template v-slot:item.content="{ item }">
              <div style="max-width: 400px; white-space: pre-wrap; font-size: 12px;">
                <span v-html="item.content"></span>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import Filtering from "@/components/Filtering";
import MHDatePicker from "@/components/daterange/MHDatePicker";
import { mapState } from "vuex";
import configs from "@/configs";
import moment from "moment";
import { sendSuccessNotice, sendErrorNotice } from "@/commons/utils";
import { print_truck_unload_list } from "@/commons/hpod";
import _ from "lodash";
export default {
  components: {
    "hpo-filter": Filtering,
    "mh-date-picker": MHDatePicker,
  },
  data() {
    return {
      orderDate: null,
      storeDate: null,
      product_status: configs.PRODUCT_STATUS,
      product_status_list: configs.PRODUCT_STATUS_LIST,
      receive_type_list: configs.RECEIVE_TYPE_LIST,
      receive_type: configs.RECEIVE_TYPE,
      detailOptions: {},
      systemLogs: [],
      loadingLogs: false,
      log_headers: [
        { text: 'Người dùng', value: 'user_name', width: '150px' },
        { text: 'Thời gian', value: 'created_at', width: '180px' },
        { text: 'Nội dung', value: 'content' },
      ],
      detail_header: [
        {
          text: "Mã KH",
          value: "CustomerCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Diều hướng",
          value: "DirectName",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Mã hàng",
          value: "Code",
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Tổng chi (¥)",
          value: "Deposit",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        // {
        //   text: "Tỷ giá",
        //   value: "ExchangeRate",
        //   align: "end",
        //   filterable: true,
        //   dataType: configs.DATA_TYPE["Number"],
        // },
        {
          text: "Cân nặng",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Thể tích",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Tổng kiện",
          value: "OrderNumberOfPack",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Đã hạ",
          value: "UnloadPack",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          values: configs.RECEIVE_TYPE_LIST,
          dataType: configs.DATA_TYPE["Enum"],
        },
        {
          text: "",
          value: "",
          align: "center",
          width: "80px",
        },
      ],
      pagination: { ...configs.PAGINATION },
      items_per_page: { ...configs.ITEMS_PER_PAGE },
      filterConditions: [],
      quickFilterConditions: [],
      dialogItem: false,
      popup_header: [
        {
          text: "Mã KH",
          value: "UserName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Điều hướng",
          value: "DirectName",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Mã hàng",
          value: "Code",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Chi tệ",
          value: "Deposit",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        // {
        //   text: "Tỷ giá",
        //   value: "ExchangeRate",
        //   align: "end",
        //   filterable: true,
        //   dataType: configs.DATA_TYPE["Number"],
        // },
        {
          text: "Cân nặng",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Thể tích",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Tổng kiện",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
        },
        {
          text: "Số lượng bốc",
          value: "LoadPack",
          align: "end",
          sortable: false,
          filterable: false,
          width: "120px"
        },
        {
          text: "Số lượng tồn",
          value: "RemainingPack",
          align: "end",
          sortable: false,
          filterable: false,
          width: "120px"
        },
        {
          text: this.$t('table_headers.product_type'),
          value: "ProductType",
          filterable: true,
          values: [],
          dataType: configs.DATA_TYPE["Enum"]
        },
      ],
      popupViewName: "popup_detail",
      selectedDetail: [],
      loadPackQuantities: {},
      showUnloadDialog: false,
      hasLicensePlate: false,
      unload_headers: [
        { text: 'Mã HN', value: 'Code', sortable: false },
        { text: 'Mã KH', value: 'UserName', sortable: false },
        { text: 'Vận đơn', value: 'SuffixBill', sortable: false },
        { text: 'Số kiện trên xe', value: 'OrderNumberOfPack', align: 'end', sortable: false },
        { text: 'Số kiện thực tế hạ', value: 'UnloadPack', align: 'end', sortable: false },
        { text: 'Còn lại', value: 'Remaining', align: 'end', sortable: false },
        { text: 'Hành động', value: 'action', align: 'center', sortable: false, width: '120px' },
      ],
    };
  },
  computed: {
    ...mapState({
      loading: state => state.order.loading,
      currentItem: state => state.order.selected,
      configuration: state => state.configuration.selected,
      details: state => state.product.orderList.data,
      total_details: state => state.product.orderList.total,
      popup_items: state => state.product.all.data,
      popup_total: state => state.product.all.total,
      product_types: state => state.productType.all.data,
    }),
    isAccountant() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Accountant || this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin;
    },
    canEditProducts() {
      // Chỉ được sửa products khi: Chưa có biển số xe, HOẶC là kế toán
      return !this.hasLicensePlate || this.isAccountant;
    },
    canEditLicensePlate() {
      // Có thể sửa biển số khi: Tạo mới (ID = 0), HOẶC chưa có biển số, HOẶC là kế toán
      return !this.currentItem.ID || !this.hasLicensePlate || this.isAccountant;
    },
    prefixBigpackages() {
      if (this.configuration && this.configuration.PrefixBigpackages) {
        const prefixs = JSON.parse(this.configuration.PrefixBigpackages);
        if (prefixs.length) {
          return prefixs.map((a) => {
            return { value: a, name: a };
          });
        }
      }
      return [];
    },
    currentId() {
      return Number(this.$route.params.Pid);
    }
  }, 
  watch: {
    currentItem() {
      this.orderDate = this.currentItem.OrderDate
        ? moment.utc(this.currentItem.OrderDate).format('YYYY-MM-DD')
        : null;
      this.storeDate = this.currentItem.StoreDate
        ? moment.utc(this.currentItem.StoreDate).format('YYYY-MM-DD')
        : null;
      this.hasLicensePlate = this.currentItem.LicensePlate && this.currentItem.LicensePlate.trim() !== '';
    },
     pagination: {
        handler: function (val, oldVal) {
            this.getAvailableProduct();
        },
        deep: true
    },
    product_types() {
        let header_item = _.find(this.popup_header, { value: "ProductType" });
        if (header_item) {
            header_item.values =
                _.map(this.product_types, (item) => {
                    return {
                        value: item.ID,
                        name: item.Name,
                    };
                }) || [];
        }
    },
    selectedDetail(newVal, oldVal) {
      // Tự động khởi tạo số lượng bốc = AvailableNumberOfPack khi chọn
      newVal.forEach(item => {
        if (!this.loadPackQuantities[item.ID]) {
          this.$set(this.loadPackQuantities, item.ID, item.AvailableNumberOfPack);
        }
      });
      // Xóa các item không còn được chọn
      const selectedIds = new Set(newVal.map(item => item.ID));
      Object.keys(this.loadPackQuantities).forEach(id => {
        if (!selectedIds.has(parseInt(id))) {
          this.$delete(this.loadPackQuantities, id);
        }
      });
    }
  },
  methods: {
    applyFilterDetail(filterConditions) {
      this.filterConditions = filterConditions;
      this.getAvailableProduct();
    },
    quickFilterDetail(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.getAvailableProduct();
    },
    getDetail() {
      if (!this.currentId) {
        this.$store.commit("order/setDetail", { ID: 0 });
        this.$store.commit("product/setOrderList", { data: [], total: 0 });
      } else {
        this.$store.dispatch("order/getDetail", this.currentId).then((ret) => {
          ret = ret.data ? ret.data : ret;
          if (_.isEmpty(ret)) {
            sendErrorNotice("Lỗi, không load được dữ liệu.");
          } else {
            this.getSystemLogs();
          }
        });
        this.$store.dispatch("product/getOrderList", this.currentId);
      }
    },
    async getSystemLogs() {
      if (!this.currentItem || !this.currentItem.ID) {
        this.systemLogs = [];
        return;
      }
      
      this.loadingLogs = true;
      try {
        const param = {
          pagination: { page: 1, itemsPerPage: 100, sortBy: ['id'], sortDesc: [true] },
          filter: [
            { column: 'function_name', value: 'Xếp xe', condition: 's_equal' },
            { column: 'object_id', value: this.currentItem.ID, condition: 'equal' }
          ]
        };
        
        const response = await this.$store.dispatch("systemLog/getList", param);
        this.systemLogs = this.$store.state.systemLog.all.data || [];
      } catch (err) {
        console.error('Error loading system logs:', err);
        this.systemLogs = [];
      } finally {
        this.loadingLogs = false;
      }
    },
    getAvailableProduct() {
      var param = {
        pagination: this.pagination,
        filter: [...this.filterConditions],
        quickFilter: this.quickFilterConditions,
        'action': 'available'
      };
      // param.filter.push({
      //   column: "Status",
      //   value: [this.product_status.xuat_kho_tq],
      //   condition: "in",
      // });
      // param.action = "ton-kho-tq";
      this.$store.dispatch("product/getList", param);
    },
    addDetail() {
      this.dialogItem = true;
      this.quickFilterConditions = [];
      this.loadPackQuantities = {};
      this.getAvailableProduct();
    },
    deleteDetail(id, product_id) {
      this.$store.dispatch("orderProduct/setDetail", {
        'data': {'ProductID': product_id, 'ActionType': 'delete'},
        'id': id
      });
    },
    onSelectDetail() {
      if(this.selectedDetail.length > 0) {
        // Validate: kiểm tra tất cả các item đã chọn phải có số lượng bốc > 0
        const invalidItems = this.selectedDetail.filter(item => {
          const loadPack = this.loadPackQuantities[item.ID] || 0;
          return loadPack <= 0 || loadPack > item.AvailableNumberOfPack;
        });
        
        if (invalidItems.length > 0) {
          sendErrorNotice('Vui lòng nhập số lượng bốc hợp lệ (> 0 và <= số kiện available) cho tất cả hàng đã chọn');
          return;
        }
        
        let submitList = [];
        let payload = {};
        if(!this.currentId) {
          payload = {
            ...this.currentItem,
            OrderDate: this.orderDate ? moment.utc(this.orderDate).format(configs.SQL_DATE_FORMAT) : null,
            StoreDate: this.storeDate ? moment.utc(this.storeDate).format(configs.SQL_DATE_FORMAT) : null,
          }
        }
        for (const item of this.selectedDetail) {
          const loadPack = this.loadPackQuantities[item.ID] || item.AvailableNumberOfPack;
          submitList.push({
            ID: item.ID,
            NumberOfPack: loadPack
          });
        }
        payload.Products = submitList;
        this.$store.dispatch("order/setDetail", {
          data: payload,
          id: this.currentItem.ID
        }).then((ret) => {
          ret = ret.data ? ret.data : ret;
          if (_.isEmpty(ret)) {
            sendErrorNotice("Lỗi, không load được dữ liệu.");
          } else if (!this.currentItem.ID) {
            this.$router.push({
              name: "TruckDetail",
              params: { Pid: ret.ID, title: `Chi tiết xếp xe` },
            });
            this.getDetail();
          }
        });
        this.selectedService = [];
        this.selectedDetail = [];
        this.loadPackQuantities = {};
        this.dialogItem = false;
      }
    },
    validateLoadPack(item) {
      const loadPack = this.loadPackQuantities[item.ID];
      if (loadPack > item.AvailableNumberOfPack) {
        this.loadPackQuantities[item.ID] = item.AvailableNumberOfPack;
      }
      if (loadPack < 0) {
        this.loadPackQuantities[item.ID] = 0;
      }
    },
    calculateRemainingPack(item) {
      const loadPack = this.loadPackQuantities[item.ID] || 0;
      return item.AvailableNumberOfPack - loadPack;
    },
    confirmUnload() {
      // Validate
      const hasUnload = this.details.some(item => (item.UnloadPack || 0) > 0);
      if (!hasUnload) {
        sendErrorNotice('Phải nhập số kiện hạ cho ít nhất một mã hàng');
        return;
      }
      
      // Cập nhật NumberOfPackImport cho từng product
      const updates = [];
      this.details.forEach(item => {
        if ((item.UnloadPack || 0) > 0) {
          updates.push({
            ID: item.ID,
            NumberOfPackImport: (item.NumberOfPackImport || 0) + (item.UnloadPack || 0),
            UnloadPack: (item.UnloadPack || 0),
            TruckID: this.currentItem.ID,
            Status: this.product_status.nhap_kho_vn
          });
        }
      });
      
      // Gọi API cập nhật
      if (updates.length > 0) {
        this.$store.dispatch('order/setDetail', {
          'data': {
            Status: this.receive_type.nhap_kho_vn
          },
          'id': this.currentItem.ID
        });
        this.$store.dispatch('product/setDetail', {
          data: { ids: updates.map(u => u.ID), NumberOfPackImport: 0, Action: 'unload', Updates: updates },
          id: -1
        }).then(() => {
          sendSuccessNotice('Hạ hàng thành công');
          this.showUnloadDialog = false;
          this.getDetail();
        }).catch(err => {
          sendErrorNotice('Lỗi khi hạ hàng: ' + err.message);
        });
      }
    },
    saveData() {
      this.$store.dispatch("order/setDetail", {
        'data': {...this.currentItem, OrderDate: this.orderDate ? moment.utc(this.orderDate).format(configs.SQL_DATE_FORMAT) : null, StoreDate: this.storeDate ? moment.utc(this.storeDate).format(configs.SQL_DATE_FORMAT) : null},
        'id': this.currentItem.ID
      });
      if(!this.currentItem.ID) {
        window.getApp.$emit("APP_NAVIGATE", "TruckList");
      }
    },
    saveOrderProduct(item) {
      this.$store.dispatch("orderProduct/setDetail", {
        'data': {
          ...item
        },
        'id': 99999999
      });
    },
    saveProductItem(item) {
      this.$store.dispatch("product/setDetail", {
        'data': {
          ...item,
          Status: item.ReceiveStatus == this.receive_type.nhap_kho_vn ? this.product_status.nhap_kho_vn : this.product_status.xuat_kho_tq
        },
        'id': item.ID
      });
    },
    saveAllProduct() {
      this.$store.dispatch("order/setDetail", {
        'data': {
          ActionType: 'update_child',
          Status: this.product_status.nhap_kho_vn,
          ReceiveStatus: this.receive_type.nhap_kho_vn
        },
        'id': this.currentItem.ID
      });
    },
    exportData() {
      this.$store.dispatch("order/exportDetail", this.currentItem.ID);
    },
    validateUnloadPack(item) {
      if (item.UnloadPack > item.OrderNumberOfPack) {
        item.UnloadPack = item.OrderNumberOfPack;
      }
      if (item.UnloadPack < 0) {
        item.UnloadPack = 0;
      }
    },
    cancelUnload() {
      this.showUnloadDialog = false;
      // Reset UnloadPack
      this.details.forEach(item => {
        item.UnloadPack = item.OrderNumberOfPack || 0;
      });
    },
    confirmUnloadItem(item) {
      // Validate
      if (!item.UnloadPack || item.UnloadPack <= 0) {
        sendErrorNotice('Phải nhập số kiện hạ hàng');
        return;
      }
      
      // Cập nhật cho 1 product
      const update = {
        ID: item.ID,
        NumberOfPackImport: (item.NumberOfPackImport || 0) + (item.UnloadPack || 0),
        UnloadPack: (item.UnloadPack || 0),
        TruckID: this.currentItem.ID,
        Status: this.product_status.nhap_kho_vn
      };
      
      // Gọi API cập nhật
      this.$store.dispatch('product/setDetail', {
        data: { ids: [update.ID], NumberOfPackImport: 0, Action: 'unload', Updates: [update] },
        id: -1
      }).then(() => {
        sendSuccessNotice(`Đã hạ ${item.UnloadPack} kiện cho mã ${item.Code}`);
        // Reset input về 0
        item.UnloadPack = 0;
        // Refresh lại danh sách
        this.getDetail();
      }).catch(err => {
        const errorMsg = err.response && err.response.data && err.response.data.message ? err.response.data.message : err.message;
        sendErrorNotice('Lỗi khi hạ hàng: ' + errorMsg);
      });
    },
    printTruckList() {
      if (this.details && this.details.length > 0) {
        // Sắp xếp dữ liệu theo thứ tự hiện tại trên bảng
        let sortedDetails = [...this.details];
        if (this.detailOptions.sortBy && this.detailOptions.sortBy.length > 0) {
          const sortBy = this.detailOptions.sortBy[0];
          const sortDesc = this.detailOptions.sortDesc && this.detailOptions.sortDesc[0];
          
          sortedDetails.sort((a, b) => {
            let aVal = a[sortBy];
            let bVal = b[sortBy];
            
            // Xử lý giá trị null/undefined
            if (aVal === null || aVal === undefined) aVal = '';
            if (bVal === null || bVal === undefined) bVal = '';
            
            // So sánh
            if (typeof aVal === 'string') {
              return sortDesc ? bVal.localeCompare(aVal) : aVal.localeCompare(bVal);
            } else {
              return sortDesc ? (bVal - aVal) : (aVal - bVal);
            }
          });
        }
        
        print_truck_unload_list(this.currentItem, sortedDetails);
      } else {
        sendErrorNotice('Không có hàng hóa để in');
      }
    }
  },
  mounted() {
    this.$store.dispatch("configuration/getDetail", 1);
    this.$store.dispatch("productType/getList");
    this.getDetail();
    this.$root.$on("REQUEST_REFRESH_DATA", this.getDetail);
    this.$root.$on("REQUEST_CREATE_DATA", this.exportData);
    this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.getDetail);
    this.$root.$off("REQUEST_CREATE_DATA", this.exportData);
    this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
  },
};
</script>